import { Skeleton } from '@/components/lemmala-design-system/skeleton/skeleton'

// Matches the comment row: avatar, author, time, then two lines of body.
export const CommentRowSkeleton = () => (
  <div className='flex flex-col gap-1.5' aria-busy='true' data-testid='comment-row-skeleton'>
    <div className='flex items-center gap-1.5'>
      <Skeleton className='size-6 rounded-full' />
      <Skeleton className='h-4 w-32' />
      <Skeleton className='h-3 w-24' />
    </div>
    <div className='flex flex-col gap-1.5 pl-8'>
      <Skeleton className='h-4 w-full' />
      <Skeleton className='h-4 w-2/3' />
    </div>
  </div>
)
